import { useQuery } from "react-query";
import React, { useState } from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { Space, Col, Row, Typography, Divider, Spin } from "antd";

import Replies from "./Replies";
import GamificationBadge from "./GamificationBadge";
import PinIcon from "../../../../assets/images/pin.svg";
import { API_STORAGE_KEY } from "../../../../constants/constant";
import CommentService from "../../../../ApiServices/comment.service";
import { getDateDifference } from "../../../../util/date-time.service";
import notificationService from "../../../../util/notification.service";
import UserIllustration from "../../../../assets/images/useravatar.svg";

const NO_OF_ROWS = 4;
const PAGINATION_OFFSET = "Pagination.Offset";
const PAGINATION_COUNT = "Pagination.Count";
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const Comment = ({ commentDetail, isHighlighted, LanguageId }) => {
    const { Paragraph } = Typography;
    const [repliesPayload, setRepliesPayload] = useState({
        PostId: commentDetail?.postId,
        CommentId: commentDetail?.id,
        LanguageId,
        [PAGINATION_OFFSET]: 0,
        [PAGINATION_COUNT]: 2
    });

    const getCommentReplies = async () => {
        const { data, ok, response } = await CommentService.getCommentReplies(repliesPayload);
        if (ok) {
            return data;
        } else {
            notificationService.error(response.message);
            throw new Error(response.message);
        }
    };
    const {
        data: repliesData,
        isFetching: repliesDataLoading,
        refetch: refetchReply
    } = useQuery(`${commentDetail?.id}-${(API_STORAGE_KEY.REPLIES_DATA, LanguageId)}`, getCommentReplies, {
        enabled: commentDetail.repliesCount > 0
    });

    const onChangePageCount = () => {
        setRepliesPayload({
            ...repliesPayload,
            [PAGINATION_COUNT]: repliesPayload[PAGINATION_COUNT] + 3
        });
        setTimeout(() => {
            refetchReply();
        });
    };

    const remainingReplies = repliesData?.filteredCount - repliesPayload[PAGINATION_COUNT];

    return (
        <Row align="center" justify="space-between" className="gx-m-0 gx-pt-2 gx-pb-2" key={commentDetail?.id}>
            <Col sm={3} xs={3} md={3} xl={3} lg={3} className="gx-p-0">
                {commentDetail?.profilePictureUrl ? (
                    <img className="image-style" src={commentDetail?.profilePictureUrl} />
                ) : (
                    <img className="icon-size-40" src={UserIllustration} />
                )}
                {commentDetail.repliesCount > 0 && <Divider type="vertical" className="vertical-comment-divider" />}
            </Col>
            <Col sm={21} xs={21} md={21} xl={21} lg={21} className="gx-p-0">
                <Row className="gx-p-0 gx-m-0">
                    <Space className="gx-mb-2">
                        <h5 className="gx-font-weight-medium gx-m-0">{commentDetail?.userName}</h5>
                        <GamificationBadge badgeList={commentDetail?.badges?.badges} />
                        <Space>
                            <img className="icon-size-14" src={PinIcon} />
                            <h6 className="gx-m-0 gx-font-weight-light gx-text-gray">
                                {commentDetail?.neighborhoodName}
                            </h6>
                        </Space>
                    </Space>
                </Row>
                <Row
                    className="gx-p-0 gx-m-0"
                    style={{ background: isHighlighted == true ? "#fffae6" : "transparent" }}
                >
                    <Paragraph
                        ellipsis={{ rows: NO_OF_ROWS, expandable: true, symbol: "more" }}
                        className="gx-font-weight-light gx-text-light-gray gx-fs-md gx-mb-2"
                    >
                        {commentDetail?.content}
                    </Paragraph>
                    <h6 className="gx-m-0 gx-font-weight-light gx-text-gray width-100per">
                        {getDateDifference(commentDetail?.createdOn)}
                    </h6>
                </Row>
                {commentDetail.repliesCount > 0 &&
                    repliesData?.list.map((replies) => <Replies repliesDetail={replies} LanguageId={LanguageId} />)}
                <Spin indicator={antIcon} spinning={repliesDataLoading} className="width-100per gx-mt-3" />
                {remainingReplies > 0 && (
                    <div
                        className="gx-fs-13 pp-text-blue cursor gx-mt-3"
                        onClick={onChangePageCount}
                    >{`${remainingReplies} more ${remainingReplies > 1 ? "replies..." : "reply..."}`}</div>
                )}
            </Col>
        </Row>
    );
};

export default Comment;
